module.exports = __webpack_public_path__ + "static/media/p-logo-tft.7161f031.svg";